import { template } from 'lodash';
import axios from './client';

const PAGE_PARTNER_READ = template('/partner/<%= partnerId %>/page');
const PAGE_PARTNER_UPLOAD_LOGO = template('/partner/<%= partnerId %>/page/<%= pageId %>/logo');
const PAGE_PARTNER_CREATE = template('/partner/<%= partnerId %>/page');
const PAGE_PARTNER_UPDATE = template('/partner/<%= partnerId %>/page/<%= pageId %>');
const PAGE_PARTNER_SETTINGS = '/partner/page/settings';

export function read(partnerId) {
  return axios.get(PAGE_PARTNER_READ({ partnerId }));
}

export function uploadLogo(partnerId, pageId, payload) {
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(PAGE_PARTNER_UPLOAD_LOGO({ partnerId, pageId }), payload, { headers });
}

export function create(partnerId, payload) {
  return axios.post(PAGE_PARTNER_CREATE({ partnerId }), payload);
}

export function update(partnerId, pageId, payload) {
  return axios.post(PAGE_PARTNER_UPDATE({ partnerId, pageId }), payload);
}

export function getSettings() {
  return axios.get(PAGE_PARTNER_SETTINGS);
}
